import { createContext } from "react";

const WebCategoryMapContext = createContext({});

export default WebCategoryMapContext;
